qw-basket-summary-mobile {
  display: flex;
  flex-flow: column;
  background-color: var(--qw-hotel-neutral-lightest);
  box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.16);
  position: relative;
  justify-content: flex-start;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 4;
  scrollbar-width: none;
  display: none;
}

@media only screen and (max-width: 768px) {
  qw-basket-summary-mobile {
    display: flex;
  }
}

qw-basket-summary-mobile .basket-skeleton {
  transform: translateY(0px);
}

.qw-basket-summary-mobile--loading {
  pointer-events: none;
}
qw-basket-summary-mobile.qw-basket-summary-mobile--loading > *,
qw-basket-summary-mobile.qw-basket-summary-mobile--loading
  .qw-basket-summary-mobile--content
  > * {
  pointer-events: none;
}

qw-basket-summary-mobile > * {
  opacity: 0;
}

qw-basket-summary-mobile.visualize-basket {
  justify-content: initial;
  max-height: 100%;
}

qw-basket-summary-mobile.visualize-basket > * {
  opacity: 1;
  transition:
    transform 0.6s cubic-bezier(0, 0.55, 0.45, 1),
    opacity 0.3s ease-in-out 0.2s;
}

qw-basket-summary-mobile .qw-loader {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.8;
  pointer-events: none;
  z-index: 2000;
}

qw-basket-summary-mobile .qw-loader:after {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #eee;
  background: linear-gradient(
    110deg,
    rgba(255, 255, 255, 0) 12%,
    white 17%,
    rgba(255, 255, 255, 0) 22%
  );
  background-size: 600% 100%;
  background-position-x: 40%;
  animation: 3s shine linear infinite;
  opacity: 0.4;
}

@keyframes shine {
  to {
    background-position-x: -200%;
  }
}

qw-basket-summary-mobile.loading-skeleton {
  background-color: var(--qw-hotel-skeleton-light);
}

.loading-skeleton .qw-basket-summary-mobile__heading {
  background-color: var(--qw-hotel-skeleton-medium);
}

.loading-skeleton .qw-basket-summary-mobile__heading h3 {
  color: var(--qw-hotel-skeleton-dark);
  background-color: var(--qw-hotel-skeleton-dark);
  border-radius: 2px;
}

.loading-skeleton
  .qw-basket-summary-mobile__heading
  .qw-basket-summary-mobile__payment
  .qw-button,
.loading-skeleton .qw-basket-summary-mobile__payment .qw-button {
  color: var(--qw-hotel-skeleton-dark);
  background-color: var(--qw-hotel-skeleton-dark);
  opacity: 1;
}

qw-basket-summary-mobile.loading-skeleton .qw-basket-summary-mobile__content p,
qw-basket-summary-mobile.loading-skeleton .qw-basket-summary-mobile__general-info h3 span,
qw-basket-summary-mobile.loading-skeleton .qw-basket-summary-mobile__general-info .session-info .session-info__dates,
qw-basket-summary-mobile.loading-skeleton .qw-basket-summary-mobile__general-info .session-info .session-info__guests,
qw-basket-summary-mobile.loading-skeleton qw-currency select,
qw-basket-summary-mobile.loading-skeleton qw-basket .qw-basket__price span,
qw-basket-summary-mobile.loading-skeleton qw-basket .qw-basket__price .qw-basket__price-total,
qw-basket-summary-mobile.loading-skeleton qw-basket .qw-basket__price .qw-basket__price-total .qw-basket__tax-total,
qw-basket-summary-mobile.loading-skeleton .qw-basket-summary-mobile__payment .qw-basket-summary-mobile__redirection-label,
qw-basket-summary-mobile.loading-skeleton .qw-basket-summary-mobile__link,
/* qw-basket-summary-mobile.loading-skeleton .qw-basket-summary-mobile__rooms, */ 
qw-basket-summary-mobile.loading-skeleton .qw-basket-summary-mobile__warning,
qw-basket-summary-mobile.loading-skeleton .redirectPayment,
qw-basket-summary-mobile.loading-skeleton .qw-basket-summary-mobile__payment-methods-wrapper p,
qw-basket-summary-mobile.loading-skeleton .qw-basket-summary-mobile__rooms .qw-basket-summary-mobile__room--wrapper p.qw-basket-summary-mobile__rate-info,
qw-basket-summary-mobile.loading-skeleton .qw-basket-summary-mobile__rooms .qw-basket-summary-mobile__room-title,
qw-basket-summary-mobile.loading-skeleton .qw-basket-summary-mobile__rooms .qw-basket-summary-mobile__rate-info .qw-basket-summary-mobile__rate-info--guest,
qw-basket-summary-mobile.loading-skeleton .qw-basket-summary-mobile__room-price,
qw-basket-summary-mobile.loading-skeleton  qw-basket .qw-basket__price + .qw-basket__on-site-tax-total,
qw-basket-summary-mobile.loading-skeleton .qw-basket-summary-mobile__rooms .qw-basket-summary-mobile__no-rooms {
  color: var(--qw-hotel-skeleton-medium) !important;
  background-color: var(--qw-hotel-skeleton-medium);
  background-size: 0;
  display: inline-block;
  width: auto;
  border-radius: 2px;
}

qw-basket-summary-mobile.loading-skeleton .qw-basket-summary-mobile__link {
  align-self: center;
}

qw-basket-summary-mobile.loading-skeleton
  .qw-basket-summary-mobile__rooms
  .qw-basket-summary-mobile__room--wrapper
  p,
qw-basket-summary-mobile.loading-skeleton
  .qw-basket-summary-mobile__section-title {
  color: var(--qw-hotel-skeleton-dark) !important;
  background-color: var(--qw-hotel-skeleton-dark);
  background-size: 0;
  display: inline-block;
  width: auto;
  border-radius: 2px;
}

qw-basket-summary-mobile.loading-skeleton
  .qw-basket-summary-mobile__payment-methods
  span,
qw-basket-summary-mobile.loading-skeleton
  .qw-basket-summary-mobile__room-delete
  .qw-button {
  background-size: 0;
  background-color: var(--qw-hotel-skeleton-dark);
  border-radius: 2px;
}

.loading-skeleton qw-basket {
  border-color: var(--qw-hotel-skeleton-dark);
}

qw-basket-summary-mobile.loading-skeleton
  .qw-basket-summary-mobile__general-info
  h3
  .icon:last-of-type {
  display: none;
}

.loading-skeleton .qw-booking-bar__input-fields qw-input label span {
  color: var(--qw-hotel-skeleton-medium);
  background-color: var(--qw-hotel-skeleton-medium);
  background-size: 0%;
}

.qw-basket-summary-mobile {
  z-index: 2;
  background-color: var(--qw-hotel-neutral-lightest);
  box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.16);
}

.qw-basket-summary-mobile-main {
  display: flex;
  padding: var(--qw-hotel-gap-md) 0;
}

.qw-basket-summary-mobile-price {
  width: 50%;
  border-right: 1px solid var(--qw-hotel-neutral-border);
  padding: 0 var(--qw-hotel-gap-md);
  position: relative;
}

.qw-basket-summary-mobile-price .qw-button.close-button {
  color: #414445;
  font-family: 'MuseoSans 700', sans-serif;
  font-size: 18px;
  text-transform: capitalize;
  background-color: var(--qw-hotel-neutral-lightest);
  border-radius: 100px;
  width: 80%;
  margin: 0 auto;
}
.qw-basket-summary-mobile-price .qw-button.close-button:before {
  content: '';
  width: 10px;
  height: 10px;
  background-image: url('#{$base-url}img/icons/close-summary-booking.svg');
  background-repeat: no-repeat;
  background-size: 100%;
  position: relative;
  margin-right: 8px;
}

.qw-basket-summary__mobile-title,
.qw-basket-summary__mobile--price-wrapper {
  opacity: 1;
  pointer-events: initial;
  transition: opacity 0.4s cubic-bezier(0.22, 1, 0.36, 1);
  &.hide {
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.4s cubic-bezier(0.22, 1, 0.36, 1);
  }
}
.qw-basket-summary-mobile-price .qw-button.close-button {
  opacity: 1;
  pointer-events: initial;
  transition: opacity 0.4s cubic-bezier(0.22, 1, 0.36, 1);
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  &.hide {
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.4s cubic-bezier(0.22, 1, 0.36, 1);
  }
}

.qw-basket-summary__mobile-title span.title {
  color: #787878;
  font: var(--qw-hotel-font-poppin-r);
  font-size: 14px;
}

.qw-basket-summary__mobile--price-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 29px;
}

.qw-basket-summary__mobile--price-wrapper qw-basket {
  padding: 0;
  margin: 0;
  border: 0;
}

.qw-basket-summary__mobile--price-wrapper qw-basket .qw-basket__price {
  width: 100%;
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
}
.qw-basket-summary__mobile--price-wrapper
  qw-basket
  .qw-basket__on-site-tax-total {
  display: none !important;
}

.qw-basket-summary__mobile--price-wrapper qw-basket .qw-basket__price span {
  display: none !important;
}

.qw-basket-summary__mobile--price-wrapper
  qw-basket
  .qw-basket__price
  .qw-basket__price-total {
  justify-content: flex-end;
  font-size: 24px;
  font-family: var(--qw-hotel-font-family-r);
}

.qw-basket-summary__mobile--price-wrapper .icon-toggle {
  background-image: url('#{$base-url}img/icons/arrow-dropdown-grey.svg');
  width: 16px;
  height: 16px;
  display: inline-block;
  background-size: 16px;
  background-position: center;
  background-repeat: no-repeat;
  vertical-align: middle;
  margin-left: 8px;
  transform: rotate(180deg);
}

.qw-basket-summary-mobile-main .qw-basket-summary-mobile-action {
  display: flex;
  justify-content: center;
  width: 50%;
  padding: 0 var(--qw-hotel-gap-md);
}
.qw-basket-summary-mobile-main .qw-basket-summary-mobile-action .qw-button {
  background-color: var(--qw-hotel-primary-color);
  border: none;
  font-family: var(--qw-hotel-font-family-b);
  font-size: 18px;
  width: auto;
  padding: 13px 16px;
  border-radius: 100px;
  width: 80%;
  margin: 0 auto;
}

.qw-basket-summary-mobile-footer {
  background-color: var(--qw-hotel-neutral-light);
  padding: var(--qw-hotel-gap-md);
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--qw-hotel-neutral-extra-label);
}

.qw-basket-summary-mobile-footer h3 {
  margin: 0 var(--qw-hotel-gap-md) 0 0;
  color: var(--qw-hotel-neutral-dark);
  font-family: var(--qw-hotel-font-family-m);
}

////////// finsih with all the other extra and rooms added style

.qw-basket-summary-mobile-footer .icon {
  background-image: url('#{$base-url}img/v2/edit-pencil.svg');
  width: 16px;
  height: 16px;
  display: inline-block;
  background-size: 16px;
  background-position: center;
  background-repeat: no-repeat;
  vertical-align: middle;
  margin-left: 8px;
}

.qw-basket-summary-mobile--content {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 100vh;
  left: 0;
  width: 100%;
  height: calc(100vh - 108px);
  flex-basis: 100%;
  transform: translateY(0vh);
  transition: transform 0.4s ease-out !important;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background-color: var(--qw-hotel-neutral-light);
  &.active {
    transform: translateY(-100vh);
    transition: transform 0.6s cubic-bezier(0.22, 1, 0.36, 1) !important;
  }

  .qw-basket-summary__actions {
    display: none !important;
  }
  qw-basket {
    border-bottom: 0;
    padding: 24px 16px 48px;
    margin: 0 0 0;
  }

  .qw-basket-summary-mobile__heading {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background-color: var(--qw-hotel-neutral-dark);
    color: var(--qw-hotel-neutral-lightest);
    padding: 18px 18px 21px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  .qw-basket-summary-mobile__heading h3 {
    color: var(--qw-hotel-neutral-lightest);
    font-size: 18px;
    margin: 0;
  }
  .qw-basket-summary-mobile__heading--close {
    display: inline-flex;
    width: 35px;
    height: 35px;
    background-image: url('#{$base-url}img/v2/close-summary-booking-white.svg');
    background-repeat: no-repeat;
    background-size: 12px;
    background-position: center center;
    position: relative;
    border: 1px solid white;
    border-radius: 20px;
    margin-left: auto;
  }

  .qw-basket-summary-mobile__content {
    padding: 0 14px 0 20px;
    margin-bottom: 36px;
    margin-top: 26px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  .qw-basket-summary-mobile__general-info {
    width: 100%;
  }

  .qw-basket-summary-mobile__general-info > p:first-of-type {
    font-family: var(--qw-hotel-font-family-r);
    color: var(--qw-hotel-neutral-300);
    font-size: 12px;
    margin: 0 0 8px;
    line-height: 1.7;
    display: inline-block;
  }
  .qw-basket-summary-mobile__general-info h3 {
    font-size: 16px;
    font-family: var(--qw-hotel-font-family-m);
    margin: 0 0 0;
    text-transform: capitalize;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .qw-basket-summary-mobile__general-info h3 span {
    display: inline-block;
    white-space: nowrap;
  }

  .qw-basket-summary-mobile__general-info h3 span .icon {
    background-image: url('#{$base-url}img/v2/edit-pencil.svg');
    width: 18px;
    height: 18px;
    display: inline-block;
    background-size: 18px;
    background-position: center;
    background-repeat: no-repeat;
    vertical-align: middle;
    margin: -5px 0 0 8px;
    cursor: pointer;
  }

  .qw-basket-summary-mobile__general-info .session-info {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .qw-basket-summary-mobile__general-info .session-info .session-info__guests {
    margin: 0;
    font-size: 12px;
    font-family: var(--qw-hotel-font-family-m);
    position: relative;
    color: var(--qw-hotel-accent-label);
  }

  .qw-select__qw-currency {
    display: flex;
    justify-content: flex-end;
    margin-right: 16px;
  }
  .qw-basket-summary-mobile__warning {
    font-size: 14px;
    line-height: 1.3;
    margin: 8px 16px;
    color: var(--qw-hotel-accent-label);
    text-align: center;
  }

  .qw-select__qw-currency select {
    background-color: transparent;
    max-width: 114px;
    padding-right: 24px;
    padding-left: 16px;
    border: none;
    font-family: var(--qw-hotel-font-family-r);
    color: var(--qw-hotel-neutral-medium);
    font-size: 12px;
    margin: 0 0 var(--qw-hotel-gap-sm);
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    background-image: url('#{$base-url}img/icons/arrow-dropdown-grey.svg');
    background-repeat: no-repeat;
    background-position: right 0.7em top 50%;
    background-size: 0.75em;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
  }

  .qw-basket-summary-mobile__rooms {
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .qw-basket-summary-mobile__rooms .qw-basket-summary-mobile__room--wrapper {
    margin-bottom: 20px;
  }
  .qw-basket-summary-mobile__rooms
    .qw-basket-summary-mobile__room--wrapper:last-of-type {
    margin-bottom: 0px;
  }

  .qw-basket-summary-mobile__rooms
    .qw-basket-summary-mobile__room--wrapper
    > p:first-child,
  .qw-basket-summary-mobile__rooms
    .qw-basket-summary-mobile__extras--wrapper
    > p:first-child {
    margin: 0 0 8px;
    font-size: 12px;
    font-family: var(--qw-hotel-font-family-r);
    color: var(--qw-hotel-neutral-300);
    line-height: 1.4;
  }

  .qw-basket-summary-mobile__rooms
    .qw-basket-summary-mobile__room--wrapper
    .qw-basket-summary-mobile__room,
  .qw-basket-summary-mobile__rooms
    .qw-basket-summary-mobile__extras--wrapper
    .qw-basket-summary-mobile__room {
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;
    display: flex;
    width: 100%;
  }
  .qw-basket-summary-mobile__rooms
    .qw-basket-summary-mobile__room--wrapper
    .qw-basket-summary-mobile__room
    .qw-basket-summary-mobile__room-name,
  .qw-basket-summary-mobile__rooms
    .qw-basket-summary-mobile__extras--wrapper
    .qw-basket-summary-mobile__room
    .qw-basket-summary-mobile__room-name {
    max-width: 70%;
    position: relative;
    width: 100%;
  }
  .qw-basket-summary-mobile__rooms
    .qw-basket-summary-mobile__room--wrapper
    .qw-basket-summary-mobile__room
    .qw-basket-summary-mobile__room-name
    .qw-basket-summary-mobile__room-title,
  .qw-basket-summary-mobile__rooms
    .qw-basket-summary-mobile__extras--wrapper
    .qw-basket-summary-mobile__room
    .qw-basket-summary-mobile__room-name
    .qw-basket-summary-mobile__room-title {
    font-size: 18px;
    max-width: 70vw;
    font-family: var(--qw-hotel-font-family-m);
  }
  .qw-basket-summary-mobile__rooms
    .qw-basket-summary-mobile__room--wrapper
    .qw-basket-summary-mobile__room
    .qw-basket-summary-mobile__room-name
    .qw-basket-summary-mobile__rate-info {
    font-size: 12px;
    font-family: var(--qw-hotel-font-family-r);
    color: var(--qw-hotel-neutral-300);
    line-height: 1.2;
  }
  .qw-basket-summary-mobile__rooms
    .qw-basket-summary-mobile__room--wrapper
    .qw-basket-summary-mobile__room
    .qw-basket-summary-mobile__room-name
    .qw-basket-summary-mobile__rate-info
    .qw-basket-summary-mobile__rate-info--guest {
    color: var(--qw-hotel-accent-label);
  }
  .qw-basket-summary-mobile__rooms
    .qw-basket-summary-mobile__room--wrapper
    .qw-basket-summary-mobile__room
    .qw-basket-summary-mobile__room-delete,
  .qw-basket-summary-mobile__rooms
    .qw-basket-summary-mobile__extras--wrapper
    .qw-basket-summary-mobile__room
    .qw-basket-summary-mobile__room-delete {
    display: flex;
    align-items: center;
    position: relative;
    justify-content: flex-end;
    min-width: 28%;
  }
  .qw-basket-summary-mobile__rooms
    .qw-basket-summary-mobile__room--wrapper
    .qw-basket-summary-mobile__room
    .qw-basket-summary-mobile__room-delete
    .qw-basket-summary-mobile__room-price,
  .qw-basket-summary-mobile__rooms
    .qw-basket-summary-mobile__extras--wrapper
    .qw-basket-summary-mobile__room
    .qw-basket-summary-mobile__room-delete
    .qw-basket-summary-mobile__room-price {
    margin: 4px 0 0 24px;
    font-size: 18px;
    order: 2;
    font-family: var(--qw-hotel-font-family-m);
    white-space: nowrap;
  }
  .qw-basket-summary-mobile__rooms
    .qw-basket-summary-mobile__room--wrapper
    .qw-basket-summary-mobile__room
    .qw-basket-summary-mobile__room-delete
    .qw-basket-summary-mobile__room-price
    + .qw-button,
  .qw-basket-summary-mobile__rooms
    .qw-basket-summary-mobile__extras--wrapper
    .qw-basket-summary-mobile__room
    .qw-basket-summary-mobile__room-delete
    .qw-basket-summary-mobile__room-price
    + .qw-button {
    position: absolute;
    top: 5px;
    left: 0;
    margin-top: -2px;
    order: 1;
    border-radius: 0;
    border: none;
    background: url('#{$base-url}img/icons/bin.svg') no-repeat center;
    background-size: 18px;
  }

  .qw-basket-summary-mobile__rooms p {
    margin: 0;
    align-self: flex-start;
  }
  qw-basket {
    border-top: 1px solid var(--qw-hotel-neutral-dark);
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    width: auto;
    margin: 22px 20px 0;
    padding: 22px 0 0;
  }
  qw-basket .qw-basket__price {
    width: 100%;
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  qw-basket .qw-basket__price + .qw-basket__on-site-tax-total {
    padding-bottom: 40px;
    margin-top: 0;
  }

  qw-basket
    .qw-basket__price
    + .qw-basket__on-site-tax-total.qw-basket__on-site-tax-total-checkout {
    padding-bottom: 0px;
  }
  qw-basket .qw-basket__price span {
    margin-top: 2px;
    font-family: var(--qw-hotel-font-family-b);
  }
  qw-basket .qw-basket__price .qw-basket__price-total {
    font-family: var(--qw-hotel-font-family-b);
  }
  qw-basket .qw-basket__price .qw-basket__price-total .qw-basket__tax-total {
    font-size: 12px;
    font-family: var(--qw-hotel-font-family-r);
  }
  .qw-basket-summary-mobile__redirection-label {
    margin: 24px 16px 0;
    font-size: 14px;
    color: var(--qw-hotel-label);
    text-align: center;
  }
}

/* Safari  */
@media not all and (min-resolution: 0.001dpcm) {
  qw-basket-summary-mobile .qw-basket-summary-mobile__heading,
  qw-basket-summary-mobile .qw-basket-summary-mobile__content,
  qw-basket-summary-mobile .qw-basket-summary-mobile__rooms,
  qw-basket-summary-mobile qw-basket,
  qw-basket-summary-mobile .qw-basket-summary-mobile__actions {
    display: block;
  }
  qw-basket-summary-mobile h3 {
    display: inline-block;
  }
  qw-basket-summary-mobile
    .qw-basket-summary-mobile__heading
    .qw-basket-summary-mobile__actions {
    float: right;
  }
}

@media only screen and (max-width: 738px) {
  qw-basket-summary-mobile .qw-modal--warning {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 100;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 1 !important;
    transform: translate(0) !important;
  }
  qw-basket-summary-mobile .qw-modal--warning__detail-content {
    position: relative;
    background-color: var(--qw-hotel-neutral-lightest);
    width: 90%;
    max-width: 749px;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px 18px 20px;
  }

  qw-basket-summary-mobile .qw-modal--warning .close-icon {
    position: absolute;
    top: var(--qw-hotel-gap-sm);
    right: var(--qw-hotel-gap-sm);
    width: 30px;
    height: 30px;
    margin: 0;
    z-index: 100;
    background: url('#{$base-url}img/icons/close-pop.svg') no-repeat center;
    background-size: contain;
    cursor: pointer;
  }

  qw-basket-summary-mobile .qw-modal--warning .qw-modal--warning__content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
  qw-basket-summary-mobile
    .qw-modal--warning
    .qw-modal--warning__content
    .qw-modal--warning__buttons {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
  }

  qw-basket-summary-mobile .qw-basket-summary-mobile__promo {
    padding: 16px 16px 17px;
  }
  qw-basket-summary-mobile .qw-basket-summary-mobile__promo p {
    line-height: 1.2;
    margin: 0;
  }

  qw-basket-summary-mobile .qw-basket-summary-mobile__promo .promo-code__title {
    font-size: 12px;
    color: var(--qw-hotel-neutral-300);
  }

  qw-basket-summary-mobile
    .qw-basket-summary-mobile__promo
    .promo-code__value
    p {
    color: var(--qw-hotel-accent-label);
  }

  qw-basket-summary-mobile .promo-code__value .promo-code__amount {
    color: var(--qw-hotel-accent-label);
    display: flex;
    align-items: center;
  }

  qw-basket-summary-mobile .qw-basket-summary-mobile__promo .promo-code__value {
    display: flex;
    justify-content: space-between;
  }

  qw-basket-summary-mobile .promo-code__value .promo-code__amount .qw-button {
    margin-left: var(--qw-hotel-gap-sm);
  }

  qw-basket-summary-mobile .qw-button--delete {
    border-radius: 0;
    border: none;
    background: url('#{$base-url}img/icons/bin.svg') no-repeat center;
    background-size: 18px;
  }

  qw-basket-summary-mobile
    > qw-basket
    .qw-basket__price
    + .qw-basket__on-site-tax-total {
    font-family: var(--qw-hotel-font-family-b);
    font-size: 12px;
    padding: 10px 0 0;
    margin: 8px 0 0px;
    display: flex;
    justify-content: flex-end;
  }
  qw-basket .qw-basket__price + .qw-basket__on-site-tax-total span {
    font-family: var(--qw-hotel-font-family-r);
    margin-right: 5px;
  }

  qw-basket-summary-mobile .qw-modal--warning__detail-content {
    padding: 40px 18px 20px;
  }

  .qw-basket-summary .qw-modal--warning__detail-content .close-icon {
    margin: 0;
  }

  qw-basket-summary-mobile
    .qw-modal--warning
    .qw-modal--warning__content
    .qw-modal--warning__buttons
    .qw-button {
    width: 100%;
    text-align: center;
    font-size: 16px;
  }
  qw-basket-summary-mobile
    .qw-modal--warning
    .qw-modal--warning__content
    .qw-modal--warning__buttons
    .qw-button:last-of-type {
    margin-top: 20px;
  }
  qw-basket-summary-mobile
    .qw-modal--warning
    .qw-modal--warning__content
    .qw-modal--warning__buttons
    .qw-button:first-of-type {
    margin-right: 0;
  }

  qw-basket-summary-mobile
    .qw-modal--warning
    .qw-modal--warning__content
    .qw-modal--warning__buttons
    .qw-button {
    width: 100%;
    text-align: center;
    font-size: 16px;
    font-family: var(--qw-hotel-font-family-b);
    padding: 12px 22px;
    border-radius: 25px;
    border: none;
    margin-left: 0;
    align-self: center;
    background-color: var(--qw-hotel-primary-color);
    margin-top: 40px;
  }
  qw-basket-summary-mobile
    .qw-modal--warning
    .qw-modal--warning__content
    .qw-modal--warning__buttons
    .qw-button:first-of-type {
    background-color: var(--qw-hotel-neutral-300) !important;
    color: var(--qw-hotel-neutral-lightest);
    margin-right: 0;
  }
  qw-basket-summary-mobile
    .qw-modal--warning
    .qw-modal--warning__content
    .qw-modal--warning__buttons
    .qw-button:last-of-type {
    margin-top: 20px;
  }
}
